/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Get_ReadyInputs */



/**
* | output |
* | --- |
* | "Get Ready!" |
*
* @param {Audio_Recorder_Get_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_get_ready = /** @type {((inputs?: Audio_Recorder_Get_ReadyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Get_ReadyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparez-vous !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Macht euch bereit!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparatevi!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приготовьтесь!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Prepararse!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("准备！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("準備しましょう！")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तैयार हो जाओ!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prepare-se!")
	return /** @type {LocalizedString} */ ("Get Ready!")
});